const assocPath = (obj, path, value) => {
  const key = path[0];
  const rest = path.slice(1);
  const child = rest.length ? assocPath(obj === null || obj === void 0 ? void 0 : obj[key], rest, value) : value;
  if (Array.isArray(obj)) {
    const arr = [...obj];
    // @ts-ignore: don't want to make changes while forking
    arr[key] = child;
    return arr;
  }
  return {
    ...obj,
    [key]: child
  };
};
var assocPath$1 = assocPath;

/*
forEntries({ key: 'value' }, (entries) => entries.map(([ key, value ]) => [ key, value ]));

basically it's like doing
Object.fromEntries(Object.entries(obj).map(fn))

It'll mostly be used as an internal util for mapping over objects
*/

const mapEntries = (obj, fn) => {
  // @ts-ignore: error after upgrading typescript, don't want to change the function
  const entries = Object.entries(obj);
  // @ts-ignore: error after upgrading typescript, don't want to change the function
  const mapped = fn(entries);
  return Object.fromEntries(mapped);
};
var mapEntries$1 = mapEntries;

/*
filterObj(obj, (key, value) => true)
*/
const filterObj = (obj, fn) => {
  return mapEntries$1(obj, entries => {
    return entries.filter(entry => {
      return fn(...entry);
    });
  });
};
var filterObj$1 = filterObj;

const groupBy = (arr, fn) => {
  return arr.reduce((acc, t) => {
    const key = fn(t);
    let group = acc[key];
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (!group) {
      acc[key] = group = [];
    }
    group.push(t);
    return acc;
  }, {});
};
var groupBy$1 = groupBy;

/*
mapObj(obj, (key, value) => [ key, value ])

maps over an object's properties, you must return a tuple of key/value pairs
this gives you the freedom to change keys as well as values if you need to
*/
const mapObj = (obj, fn) => {
  return mapEntries$1(obj, entries => {
    return entries.map(entry => {
      return fn(...entry);
    });
  });
};
var mapObj$1 = mapObj;

/*
{ key: 'value' } -> { value: 'key' }
*/
const invertObj = obj => {
  return mapObj$1(obj, (key, value) => [value, key]);
};
var invertObj$1 = invertObj;

const isEmpty = obj => {
  if (obj === null) {
    return false;
  }
  if (obj === undefined) {
    return true;
  }
  // @ts-ignore: error after upgrading typescript, don't want to change the function
  if (obj === '') {
    return true;
  }
  if (Array.isArray(obj)) {
    return obj.length === 0;
  }
  if (typeof obj === 'object') {
    // @ts-ignore: don't want to make changes while forking
    return Object.keys(obj).length === 0;
  }
  return false;
};
var isEmpty$1 = isEmpty;

const isNilOrEmpty = obj => obj == null || isEmpty$1(obj);
var isNilOrEmpty$1 = isNilOrEmpty;

/*
omit(obj, [ 'propA', 'propB' ])
*/

const omit = (obj, keys) => {
  const result = {
    ...obj
  };
  keys.forEach(k => {
    delete result[k];
  });
  return result;
};
var omit$1 = omit;

export { assocPath$1 as assocPath, filterObj$1 as filterObj, groupBy$1 as groupBy, invertObj$1 as invertObj, isEmpty$1 as isEmpty, isNilOrEmpty$1 as isNilOrEmpty, mapEntries$1 as mapEntries, mapObj$1 as mapObj, omit$1 as omit };
